import React, { useState } from "react";
import { Form, Input, Button, Checkbox, message } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { login } from "../../services/authService";
import { useNavigate } from "react-router-dom";
import { publicIp } from "public-ip";
import { isDesktop, browserName, isMobile, isTablet, osName } from "react-device-detect";

export default function Login() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleLogin = async (req: { email: string, password: string }) => {
        try {
            setLoading(true);
            const ip = await publicIp();
            const device = {
                ip,
                browser: browserName,
                os: osName,
                isMobile: isMobile,
                isTablet: isTablet,
                isDesktop: isDesktop
            };
            const response = await login(req.email, req.password, device);
            if (response.token) {
                message.success("Đăng nhập thành công");
                if (response?.user?.role === "admin") {
                    navigate("/admin/exams");
                } else {
                    navigate("/");
                }
            }
        } catch (error) {
            message.error(error.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="flex justify-center items-center h-screen bg-[#f0f2f5]">
            <Form
                name="login_form"
                onFinish={(values) => {
                    handleLogin(values);
                }}
                className="w-full max-w-md p-6 bg-white rounded-lg shadow-md"
            >
                <h2 className="text-center text-2xl mb-6 font-semibold">Đăng Nhập</h2>
                <Form.Item
                    name="email"
                    rules={[{ required: true, message: "Vui lòng nhập tên đăng nhập!" }]}
                >
                    <Input
                        prefix={<UserOutlined className="text-gray-400" />}
                        placeholder="Tên đăng nhập"
                        size="large"
                        className="h-12"
                    />
                </Form.Item>
                <Form.Item
                    name="password"
                    rules={[{ required: true, message: "Vui lòng nhập mật khẩu!" }]}
                >
                    <Input.Password
                        prefix={<LockOutlined className="text-gray-400" />}
                        placeholder="Mật khẩu"
                        size="large"
                        className="h-12"
                    />
                </Form.Item>
                <Form.Item name="remember" initialValue={true}>
                    <Checkbox>Ghi nhớ đăng nhập</Checkbox>
                </Form.Item>
                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        block
                        size="large"
                        className="h-12 text-base"
                        loading={loading}
                    >
                        Đăng nhập
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
}